<div class="footer-holder" *ngIf="(feedbackLoaded$ | async) && (templateWithoutResults || (resultsLoaded$ | async))">
  <div class="logo-holder">
    <img [src]='environment?.mediaUrl + feedback?.image_url'/>
  </div>
</div>
